import clsx from "clsx";
import { useAtom } from "jotai";
import { useCallback, useMemo } from "react";

import { getTotalSweepEntries, handleAssetUrl } from "../../../shared/utils";
import { FKC_ENTRIES_PER_CARD, FKC_MAX_CARD_COUNT, FKC_MAX_ENTRIES } from "../../fkc.constants";
import { pagesAtom } from "../../fkc.state";
import { Pages } from "../../fkc.types";

export function OptInPage(): JSX.Element {
  const [, setPage] = useAtom(pagesAtom);

  const skipFkc = useCallback((): void => {
    window.theme.FkcUtils.skip();
  }, []);

  const goToRegistrationPage = useCallback((): void => {
    setPage(Pages.REGISTRATION);
  }, [setPage]);

  const totalEntries = useMemo(() => {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    return getTotalSweepEntries(submission?.data);
  }, []);

  return (
    <>
      <div className="lander__cpl__quiz__header">
        <div className={clsx("lander__cpl__quiz__header--earned-entries", "fkc__header--earned-entries")}>
          {`Your entries ${totalEntries}`}
        </div>
        <span className={clsx("lander__cpl__quiz__header--description", "fkc__description")}>
          Join FindKeepCash and earn up to {FKC_MAX_ENTRIES} extra entries
        </span>
        <div className="lander__quiz__header--progress-bar--container">
          <div className="progress-bar-container">
            <div
              className="progress-bar-indicator"
              style={{ width: "0%" }}
            />
          </div>
        </div>
      </div>

      <div className="fkc__video">
        <video
          autoPlay
          muted
          loop
          playsInline
          controls
          className="fkc__video--container"
        >
          <source
            src="https://cdn.shopify.com/videos/c/o/v/f8cc899e143347f2a849a73155d35014.mp4"
            type="video/mp4"
          />
        </video>
      </div>

      <img
        src={handleAssetUrl("fkc_logo.svg")}
        alt="FindKeepCash Logo"
        className="fkc__optin--logo"
      />

      <div className={clsx("fkc__content", "auto")}>
        <div className="fkc__content--header">
          <div className="fkc__content__header--entries--value">
            +{FKC_MAX_ENTRIES} Entries
          </div>
          <div className="fkc__content__header--container">
            <p className="fkc__content__header--title">
              Want to earn up to {FKC_MAX_ENTRIES} extra entries + 
              Cash Back on eligible purchases you are already making?
            </p>
            <p className="fkc__content__header--description">
              Sign up for FindKeepCash. Link up to {FKC_MAX_CARD_COUNT} credit cards (using Plaid). 
              You&apos;ll earn {FKC_ENTRIES_PER_CARD} extra entries per card + cash back on eligible purchases.
            </p>
          </div>
        </div>

        <div className={clsx("lander__cpl__quiz__body", "fkc__content--buttons-body")}>
          <div className="lander__cpl__quiz__body--question-container">
            <div className="lander__cpl__quiz__body--question-actions">
              <div className="lander__cpl__quiz__body--button-container">
                <button className="lander-quiz--button" onClick={goToRegistrationPage}>
                  Yes, I&apos;m interested
                </button>
              </div>
              <div className="lander__cpl__quiz__body--button-container">
                <button className="lander-quiz--button" onClick={skipFkc}>
                  No thanks, maybe later
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
